<template>
  <div class="contratoDigital">
    <div v-if="loader" class="iloader row justify-center align-center">
      <Loader />
    </div>
    <Clicksign v-if="minuta.length || id.length" :minuta="minuta" :id="id" :modal="modal" />
    <div class="buttons text-center">
      <div v-if="status == 'pendente'" class="warn">A assinatura do contrato estará disponível após aprovação de seu cadastro.</div>
      <div v-if="status == 'em_processamento'" class="warn">Em processamento.</div>
      <div v-if="status == 'assinado'" class="ok">Contrato assinado.</div>
      <div v-if="status == 'cancelado'" class="error">Pedido de assinatura de contrato cancelado. Entre em contato com a
        NS Resolve através do e-mail
        <a style="text-decoration: underline;" href="mailto:nsresolve@netsupport.com.br"
          target="_blank">nsresolve@netsupport.com.br.</a>
      </div>
      <div v-if="contrato && contrato.assinado_em && contrato.assinado_em.length" class="info text-center">Assinado
        em<br />{{ contrato.assinado_em | date }}</div>
      <div v-if="status == 'expirado'" class="error">Pedido de assinatura de contrato expirado.<br />Para gerar um novo
        contrato, clique no botão logo
        abaixo:</div>
      <Button v-if="status == 'expirado'" :loader="load" layout="green-m" @click="novoContrato">GERAR NOVO
        CONTRATO</Button> 
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Loader from "@/components/Loader";
import Clicksign from "@/components/modal/Clicksign.vue";
import Button from "@/components/Button.vue";

export default {
  components: { Clicksign, Button, Loader },
  props: { modal: Object },
  data() {
    return { load: false, loader: true, minuta: "", id: "", status: "", contrato: {} };
  },
  methods: {
    ...mapActions("user", ["CLICKSIGN_NOVO_CONTRATO","CONTRATO_ASSINADO", "CONTRATO_MINUTA", "CLICKSIGN_CONTRATO", "CONTRATO_GET"]),
    async getContrato(ID) {
      await this.CONTRATO_GET(ID)
        .then(({ data }) => {
          if (data && data.arquivo_minuta) this.minuta = data.arquivo_minuta
        })
      this.loader = false
    },
    async novoContrato() {
      this.load = true
      await this.CLICKSIGN_NOVO_CONTRATO({id: this.user.id_doutor, operacao: this.modal.operacao })
        .then(({ data }) => {
          if (data.status) {
            this.contrato = data
            this.status = data.status
            this.$forceUpdate()
          }
        })
        this.load = false
    }
  },
  beforeMount() {
    if (this.modal.minuta) {
      this.getContrato(this.modal.minuta)
    } else {
      var p = { op: this.modal.operacao }
      if (this.modal.id_doutor) p.id = this.modal.id_doutor
      this.CLICKSIGN_CONTRATO(p).then(async ({ data }) => {

        if (data && data.status) {
          this.contrato = data
          this.status = data.status

          if (this.status == 'pendente' || this.status == 'expirado' || this.status == 'cancelado' || this.status == 'em_processamento') {
            this.CONTRATO_MINUTA(this.modal.id_pendencia).then((r) => {
              if (r.data && r.data.arquivo_minuta)
                this.minuta = r.data.arquivo_minuta

              this.loader = false
            }).catch(() => this.loader = false)
          }

          if (this.status == 'aguardando_assinatura') {
            this.id = this.contrato.chave_requisicao_assinatura
            this.loader = false
          }

          if (this.status == 'disponivel_download' || this.status == 'assinado') {
            this.CONTRATO_ASSINADO(p).then(({ data }) => {
              if (data && data.arquivo_base64) this.minuta = data.arquivo_base64
              this.loader = false
            })

          }

        }
      })
    }
  },

  computed: {
    ...mapGetters("user", ["user"])
  }
}
</script>

<style lang="scss" scoped>
@use "@/assets/scss/vars.scss" as *;

.contratoDigital {
  color: $gray-6;
  padding: 10px 30px;
  max-width: 900px;
  border-radius: 12px;
  background: $white;

  .iloader {
    min-height: 200px;
  }

  .buttons {
    padding: 20px;
  }

  .status {
    margin-left: -21%;
  }

  .info {
    color: $purple;
  }

  .ok {
    color: $green;
    font-size: 14px;
    margin-bottom: 12px;
  }

  .warn,
  .error {
    color: $red-1;
    font-size: 15px;
    margin-bottom: 12px;
    font-weight: bold;
  }

  iframe {
    border: none;
  }
}
</style>
